import customers from './customers'
import employees from './employees'
import orders from './orders'

export default {
    customers,
    employees,
    orders
}